<template>
  <v-alert
    v-if="visible"
    color="alert_error"
    class="payment-error-bar ma-0 rounded-0"
    dark
    prominent
    dismissible
    @input="onDismiss"
  >
    <div class="d-flex align-center">
      <v-icon small color="white" class="mr-2">mdi-alert-circle</v-icon>
      <span>{{ $t('Account.paymentError') }}</span>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'PaymentErrorBar',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = this.hasPaymentErrorParam();
  },
  methods: {
    hasPaymentErrorParam() {
      return new URLSearchParams(window.location.search).get('payment-error') === 'true';
    },
    onDismiss(show) {
      if (show) {
        return;
      }
      this.visible = false;
      this.removePaymentErrorParam();
    },
    removePaymentErrorParam() {
      const url = new URL(window.location.href);
      url.searchParams.delete('payment-error');
      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      window.history.replaceState({}, '', nextUrl);
    },
  },
};
</script>

<style scoped>
.payment-error-bar {
  flex: 0 0 auto;
}
</style>
